import { creatorbase } from '@round/api';

/**
 * The accounts the upload created, once each. Only a created item has an account, and the same
 * account can come up under more than one item when it was pasted twice.
 */
export const getCreatedAccountIds = (items: creatorbase.CreatorBulkUploadItem[]): number[] => {
    const ids = items
        .filter((item) => item.status === 'CREATED')
        .map((item) => item.client_influencer_account_id)
        .filter((id): id is number => typeof id === 'number');

    return [...new Set(ids)];
};

export const formatCreatorCount = (count: number) => `${count} creator${count === 1 ? '' : 's'}`;
